import { vuexfireMutations } from 'vuexfire'
import firebase from "firebase";
import Vue from "vue";
import Vuex from "vuex";
import Auth from "./modules/auth"
import Menu from "./modules/menu"
import Item from "./modules/items"
import Category from "./modules/categories"
import MenuView from "./modules/viewmenu"
import Cart from "./modules/cart"
import Order from "./modules/orders"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ToastArray: [],
    uploadValue: [],
  },
  mutations: {
    ...vuexfireMutations,
    UPDATE_UPLOAD_VALUE(state, { index, name, progress }) {
      const fileIndex = state.uploadValue.findIndex((x) => x.index === index);
      if (fileIndex === undefined || fileIndex === -1) {
        state.uploadValue.push({ index, name, progress });
      } else {
        state.uploadValue[fileIndex].progress = progress;
      }
    },
    RESET_UPLOAD_VALUE(state) {
      state.uploadValue = [];
    },
    ADD_TO_TOAST(state, data) {
      state.ToastArray.push(data);
    },
  },
  actions: {
    async uploadPhoto({ commit, dispatch }, { file, index }) {
      const storageRef = firebase
        .storage()
        .ref(`${file.name}`)
        .put(file);
      await storageRef.on(
        `state_changed`,
        (snapshot) => {
          commit("UPDATE_UPLOAD_VALUE", {
            index,
            name: file.name,
            progress: (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
          });
        },
        (error) => {
          const data = {
            title: "Error",
            message: error.message,
          };
          commit("ADD_TO_TOAST", data);
        }
      );
      return storageRef;
    },
    async getImgUrl({ commit, dispatch }, storageRef) {
      const img = await storageRef.ref.getDownloadURL().then((url) => {
        return url;
      });
      return img;
    },

    async getUrlArray({ commit, dispatch }, files) {
      const urlArray = files.map(async (file, index) => {
        const storageRef = await dispatch("uploadPhoto", { file, index });
        const url = await dispatch("getImgUrl", storageRef);
        return url;
      });

      return await Promise.all(urlArray);
    },

    resetUploads({ commit }) {
      commit("RESET_UPLOAD_VALUE");
    },
  },
  modules: {
    Auth,
    Menu,
    Item,
    Category,
    MenuView,
    Cart,
    Order
  },
});
